import { derived, writable } from 'svelte/store';
import config from '../config';

// detecting dev environment
let is_dev = false;
if (window.location.host === 'localhost:5000') {
  is_dev = true;
}
export const dev = is_dev;

export const config_values = writable({panel_open: true});
export const leaflet_map = writable('');
export const meteo_data = writable({});
export const marker_data = writable({});
export const open_config_widget = writable('location');
export const meteo_data_updated = writable('');
